import React from 'react';
import { ExtraData } from '../styles/common.styles';

const UncertaintyConfidence = ({ confidence }) => {
  if (!confidence) return null;
  return (
    <ExtraData data-name="uncertainty-confidence">
      Confidence: {confidence}%
    </ExtraData>
  );
};

export default UncertaintyConfidence;
